import * as React from 'react'

import { Box, Button, Form } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import AccessGroupForm from 'modules/surveys/components/AccessGroupForm'
import GroupSelection from 'modules/surveys/components/GroupSelection'
import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

function groupableType(accessGroup: AccessGroup) {
  switch (accessGroup.attributes.strategy) {
    case AccessGroup.Strategies.employees:
    case AccessGroup.Strategies.withRegularAccess:
      return AccessGroup.CompanyGroup

    default:
      return accessGroup.attributes.groupable_type
  }
}

interface Props {
  accessGroup: AccessGroup
  survey: SurveyForm | Survey
  canEditSurvey: boolean
  onSubmit: (...args: any[]) => any
}

function GroupForm({ accessGroup, survey, onSubmit, canEditSurvey }: Props) {
  const disabled = !canEditSurvey
  const [running, setRunning] = React.useState(false)
  const isAnonymousSurvey = survey.attributes.anonymous

  const form = React.useRef(
    new AccessGroupForm({
      strategy: accessGroup.attributes.strategy,
      groupable_id: accessGroup.attributes.groupable_id,
      groupable_type: groupableType(accessGroup),
    })
  ).current

  const submit = async () => {
    if (!form) return

    setRunning(true)

    const { success } = await asyncAction(async () => {
      // This request is now handle under /surveys access group controller
      // Current situation: Surveys acces group controller is for memberships when manual selection and also reserving update for editing access group definition on dinamic selection
      // After refactor ther will be only one endpoint and model to handle membership with no chance of editing access group definition
      const url = '/surveys/access_groups/' + accessGroup.attributes.id
      await apiClient()['patch'](url, {
        surveys_form_id: survey.id,
        ...form.data(),
      })
      form.cleanAll()
    })
    setRunning(false)

    if (success) {
      onSubmit()
    }
  }

  // NOTE: Access groups with strategy members cannot be edited, thus we don't
  // display the form.
  if (accessGroup.attributes.strategy === AccessGroup.Strategies.members) {
    return null
  }

  return (
    <Box gap="s16">
      <GroupSelection
        disabled={disabled || !survey.isDraft || isAnonymousSurvey}
        strategy={form.get('strategy')}
        groupField={form.get('groupable_type')}
        groupableIdField={form.get('groupable_id')}
      />
      {form.isDirty && (
        <Form.Buttons>
          <Button disabled={disabled || !form.valid || running} onClick={submit}>
            {i18n.t('surveys.form.participants.group_form.submit')}
          </Button>
        </Form.Buttons>
      )}
    </Box>
  )
}

export default observer(GroupForm)
